import eventsModule from "./type";

const getters = {
    [eventsModule.getters.membershipRequests]: state => eventId => {
        return state.membershipRequests[eventId] || false
    },
    [eventsModule.getters.membershipExists]:state => id => {
        return state.myMemberships[id] !== undefined;
    },
    [eventsModule.getters.type]: state => {
        return state.type
    },
    [eventsModule.getters.spots]: state => {
        return state.spots;
    },
    [eventsModule.getters.getEventLikeInProcess]: state => {
        return state.event_like_in_process;
    },
    [eventsModule.getters.event]: state => {
        return state.source.event
    },
    [eventsModule.getters.bang]: state => {
        return state.source.bang
    },
    [eventsModule.getters.spot]: state => {
        return state.source.spot
    },
    [eventsModule.getters.eventDates]: state => {
        return state.eventDates
    },
    [eventsModule.getters.eventTransitionEnabled]: state => {
        return state.eventTransitionEnabled
    },
    [eventsModule.getters.eventIdsByDate]: state => date => {
        let existedDateIndex = state.eventDates.findIndex(v => v.date === date)
        if (existedDateIndex === -1) {
            return []
        }
        let existedEntry = state.eventDates[existedDateIndex]
        let lowRangeEventIds = existedEntry.events_range_low.map(event => {
            return event.id
        })
        return lowRangeEventIds
    },
    [eventsModule.getters.stickyEvents]: state => {
        return state.stickyEvents[state.type]
    },
}

export default getters
